import React from 'react';

const VersionPage = () => (
  <div className="VersionPageContainer">tag={process.env.REACT_APP_tag}</div>
);

export default VersionPage;
